/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IComponentProps } from '@msdyn365-commerce/core';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import React from 'react';
import { ImarketingMaterialDialogConfigs } from './../buybox.view';
export interface IDuplicateItemsWhenAddingToOrderTemplateDialogResources {
    duplicatedProductsHeader: string;
    duplicatedProductsDescription: string;

    updateQuantityButtonText: string;
    cancelDuplicateItemsButtonText: string;
    marketingMaterialDialogConfigs?: ImarketingMaterialDialogConfigs;
}

export interface IDuplicateItemsWhenAddingToOrderTemplateDialogProps extends IComponentProps {
    className: string;
    dialogStrings: IDuplicateItemsWhenAddingToOrderTemplateDialogResources;

    modalOpen: boolean | undefined;
    executeOverrideQuantity(): Promise<void>;
    onCancel(): void;
}

export const DuplicateItemsWhenAddingToOrderTemplateDialog = (dialogProps: IDuplicateItemsWhenAddingToOrderTemplateDialogProps) => {
    const { dialogStrings, className, modalOpen, executeOverrideQuantity } = dialogProps;
    const marketingMaterialDialogConfigs = dialogStrings?.marketingMaterialDialogConfigs;
    return (
        <Modal isOpen={modalOpen} className={`${className}`} toggle={dialogProps.onCancel}>
            <ModalHeader className={`${className}__dialog__header`} toggle={dialogProps.onCancel}>
                <span>
                    {marketingMaterialDialogConfigs && marketingMaterialDialogConfigs.heading ? marketingMaterialDialogConfigs.heading : ''}
                </span>
            </ModalHeader>
            <ModalBody className={`${className}__dialog__body`}>
                <div className={`${className}__dialog__content`}>
                    <div className={`${className}__dialog__description`}>
                        {marketingMaterialDialogConfigs && marketingMaterialDialogConfigs.description
                            ? marketingMaterialDialogConfigs.description
                            : ''}
                    </div>
                </div>
            </ModalBody>
            {!marketingMaterialDialogConfigs && (
                <ModalFooter className={`${className}__dialog__footer`}>
                    <Button
                        className={`${className}__dialog__update-quantity-button`}
                        title={dialogStrings.updateQuantityButtonText}
                        onClick={executeOverrideQuantity}
                    >
                        {dialogStrings.updateQuantityButtonText}
                    </Button>
                    <Button
                        className={`${className}__dialog__cancel-button`}
                        title={dialogStrings.cancelDuplicateItemsButtonText}
                        onClick={dialogProps.onCancel}
                    >
                        {dialogStrings.cancelDuplicateItemsButtonText}
                    </Button>
                </ModalFooter>
            )}
        </Modal>
    );
};
